// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2vznW","ScrollX":"Scroll_ScrollX__1REgW","ScrollY":"Scroll_ScrollY__2-RKA"};